import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import app from './modules/app'
import addCase from './modules/addCase'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    addCase,
    user,
    app
  },
  getters
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js